import { render, staticRenderFns } from "./JSelectUserByDep.vue?vue&type=template&id=60705c20&scoped=true&"
import script from "./JSelectUserByDep.vue?vue&type=script&lang=js&"
export * from "./JSelectUserByDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60705c20",
  null
  
)

export default component.exports